module.exports = __webpack_public_path__ + "media/Loops 110 Pad.3feaada0.wav";